import { render, staticRenderFns } from "./metainfo.vue?vue&type=template&id=4788956d"
import script from "./metainfo.vue?vue&type=script&lang=js"
export * from "./metainfo.vue?vue&type=script&lang=js"
import style0 from "./metainfo.vue?vue&type=style&index=0&id=4788956d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports